const userLogType = {
  ROLES: 'roles',
  PERMISSION: 'permission',
  ORDERED_PARTS: 'orderedParts',
  WAREHOUSE_PARTS: 'warehouseParts',
  CO_ORDER: 'coOrder',
};

export const userLogTypeList = [
  { label: userLogType.ROLES, value: 1 },
  { label: userLogType.PERMISSION, value: 2 },
  { label: userLogType.ORDERED_PARTS, value: 3 },
  { label: userLogType.WAREHOUSE_PARTS, value: 4 },
  { label: userLogType.CO_ORDER, value: 5 },
];

export default userLogType;
